export default "__VITE_ASSET__Bcw5maYq__"